import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  ajoutChariot,
  suppChariot,
  saveAdressePaie,
  resetChariot,
  saveVariableGlo,
} from "../actions/chariotActions";
import { creerCommande } from "../actions/commandeActions";
import { COMMANDE_CREER_RESET } from "../constantes/commandeConstantes";
import { CHARIOT_RESET } from "../reducers/chariotReducers";
import { ParamParCliAction } from "../actions/paramAppActions";
import { listeClients } from "../actions/clientsActions";
import { useNavigate, useLocation } from "react-router-dom";
import html2pdf from "html2pdf.js";
import "../CommandeRecap.css";

const CommandeRecap = () => {
  const lien = "https://gestpro.globalsystempro.com";
  const [ppdf, setPpdf] = useState(false);
  const [lang, setLangue] = useState("");
  const [source, setSource] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  // Get route params from location state
  const { cliR, commentaire } = location.state || {};

  const chariot = useSelector((state) => state.chariot);
  const {
    chariotListe,
    livraisonAdresse,
    methodePaie,
    date_livraison,
    varGlo,
  } = chariot;

  const cl = useSelector((state) => state.client);
  const { client } = cl;
  const cListe = useSelector((state) => state.clientsListeState);
  const { clients } = cListe;
  const [repInfo, setRepInfo] = useState({});

  // Calculate prices
  chariot.articlesPrix = chariot.chariotListe.reduce(
    (acc, i) => acc + i.prix_total,
    0
  );
  chariot.livraisonPrix = 0;
  chariot.totalePrix = Number(
    (chariot.livraisonPrix + chariot.articlesPrix).toFixed(2)
  );

  const com = useSelector((state) => state.commandeCreer);
  const { commande, succes } = com;
  const para = useSelector((state) => state.mesParams);
  const { params } = para;
  let compteur = 0;

  useEffect(() => {
    let unmounted = false;
    console.log("taille chariot:" + chariotListe.length);
    if (compteur > 0) {
      alert("chariot est vide");
      retourHandler();
    } else {
      setLangue(chariotListe[0].langue);
      setSource(chariotListe[0].source);

      dispatch(ParamParCliAction(client._id)); //params
      if (cliR) {
        repId(clients);
      }

      params.map(function (p, i) {
        if (p.code_param === "PPDF" && p.valeur) {
          return setPpdf(true);
        }
      });
      compteur++;
      commandeHandler(); //commande
    }

    return () => {
      console.log("unmounted code commande Recap");
      unmounted = true;
    };
  }, []);

  const createPDF = () => {
    const element = document.createElement("div");
    element.innerHTML = `
      <div style="display: flex; flex-direction: column; flex-grow: 1">
        <div style="flex: 1; background-color: #fff; display: flex; flex-direction: row; flex-wrap: wrap">
          <div style="flex: 1">
            <h1 style="font-size: 18px; font-weight: bold">Client</h1>
            <p style="font-size: 16px">Nom: ${client.nom_cli}</p>
            <p style="font-size: 16px">Code Tarif: ${client.cod_tarif}</p>
          </div>
          <div style="flex: 1">
            <h1 style="font-size: 18px; font-weight: bold">Livraison</h1>
            <p style="font-size: 16px">Adresse: ${livraisonAdresse.adresse}</p>
            <p style="font-size: 16px">Code Postale: ${
              livraisonAdresse.codepostale
            }</p>
            <p style="font-size: 16px">Ville: ${livraisonAdresse.ville}</p>
          </div>
        </div>
        <div style="flex: 1">
          <h1 style="font-size: 18px; font-weight: bold">Articles Commandées</h1>
          ${chariotListe
            .map(
              (item) => `
            <div style="display: flex; flex-direction: row; margin-bottom: 10px">
              <img 
                src="${lien + item.image}" 
                style="width: 70px; height: 70px; border-radius: 10px; margin-right: 10px"
                alt="${item.nom}"
              />
              <div style="flex: 2">
                <p style="color: rgb(0,120,212); font-size: 16px">${
                  item.nom
                }</p>
              </div>
              <div style="flex: 1">
                <p style="font-size: 16px">${item.qty}</p>
              </div>
              <div style="flex: 1">
                <p style="font-size: 16px">${item.prix_total} DT</p>
              </div>
            </div>`
            )
            .join("")}
        </div>
        <div style="flex: 1">
          <h1 style="font-size: 18px; font-weight: bold">Prix de la commande</h1>
          <p style="font-size: 16px">Articles: ${chariot.articlesPrix}</p>
          <p style="font-size: 16px">Livraison: ${chariot.livraisonPrix}</p>
          <p style="font-size: 16px">Prix Totale: ${chariot.totalePrix}</p>
        </div>
      </div>
    `;

    const opt = {
      margin: 10,
      filename: `commande_${client.nom_cli}.pdf`,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
    };

    html2pdf().from(element).set(opt).save();
  };

  const repId = (clients) => {
    const foundClient = clients?.find((cli) => cli?.cod_cli === cliR);
    if (foundClient) {
      setRepInfo(foundClient);
    }
  };

  const commandeHandler = () => {
    if (client.nivcli_cloud == "R" || client.nivcli_cloud == "A") {
      if (client.nom_cli == "google") {
        dispatch(
          creerCommande({
            client: clients?.find((cli) => cli.cod_cli == cliR)._id,
            nom_cli: clients?.find((cli) => cli.cod_cli == cliR).nom_cli,
            cod_cli: clients?.find((cli) => cli.cod_cli == cliR).cod_cli,
            chariotListe: chariotListe,
            livraisonAdresse: livraisonAdresse,
            methodepaiement: methodePaie,
            articlesPrix: chariot.articlesPrix,
            livraisonPrix: chariot.livraisonPrix,
            totalePrix: chariot.totalePrix,
            date_livraison: date_livraison,
            cod_rep: null,
            commentaire,
          })
        );
        dispatch(resetChariot());
        dispatch(saveVariableGlo(client));
      } else {
        dispatch(
          creerCommande({
            //les parametre suivants sont envoyes par le composant sous forme des parametre de l'action creerCommandes qui a été importé
            //a partir de fichiet commandeaction.js ,les parametre envoyée dans un
            client: clients.find((cli) => cli.cod_cli == cliR)._id,
            nom_cli: clients.find((cli) => cli.cod_cli == cliR).nom_cli,
            cod_cli: clients.find((cli) => cli.cod_cli == cliR).cod_cli,
            chariotListe: chariotListe,
            livraisonAdresse: livraisonAdresse,
            methodepaiement: methodePaie,
            articlesPrix: chariot.articlesPrix,
            livraisonPrix: chariot.livraisonPrix,
            totalePrix: chariot.totalePrix,
            date_livraison: date_livraison,
            cod_rep: client.cod_cli,
            commentaire,
          })
        );
        dispatch(resetChariot());

        dispatch(saveVariableGlo(null));
      }
    } else {
      console.log("lancer commande client finale");
      dispatch(
        creerCommande({
          client: clients.find((cli) => cli.cod_cli == cliR)._id,
          nom_cli: clients.find((cli) => cli.cod_cli == cliR).nom_cli,
          cod_cli: clients.find((cli) => cli.cod_cli == cliR).cod_cli,
          chariotListe: chariotListe,
          livraisonAdresse: livraisonAdresse,
          methodepaiement: methodePaie,
          articlesPrix: chariot.articlesPrix,
          livraisonPrix: chariot.livraisonPrix,
          totalePrix: chariot.totalePrix,
          date_livraison: date_livraison,
          cod_rep: null,
          commentaire,
        })
      );
      //dispatch(resetChariot());
      alert("apres reset chariot:" + chariotListe.length);
      dispatch(saveVariableGlo(client));
    }

    if (ppdf) {
      createPDF();
    }
    alert(compteur);
    //chaque fin est validation de commande a vider le variable glo qui est l'objet de client déja choisi avec un dispatch de l'action saveVariableGlo
  };

  const retourHandler = () => {
    if (chariotListe[0].source === "F") {
      if (client.nivcli_cloud === "F") {
        navigate("/DemCliFinale", {
          state: { langue: chariotListe[0].langue },
        });
      } else if (client.nivcli_cloud === "R") {
        navigate("/DemRepres", { state: { langue: chariotListe[0].langue } });
      } else {
        navigate("/DemAdmin", { state: { langue: chariotListe[0].langue } });
      }
    } else {
      navigate("/marque-liste", { state: { langue: lang } });
    }

    dispatch({ type: COMMANDE_CREER_RESET });
  };

  return (
    <div className="commande-recap-container">
      <div className="commande-recap-content">
        <div className="articles-section">
          <h2 className="section-title">Articles Commandées</h2>
          <div className="articles-list">
            {chariotListe.map((item, i) => (
              <div key={i} className="article-item">
                <img
                  src={lien + item.image}
                  alt={item.nom}
                  className="article-image"
                />
                <div className="article-details">
                  <h3 className="article-name">{item.nom}</h3>
                  <p className="article-price">{item.prix_total} DT</p>
                </div>
                <div className="article-quantity">
                  <p>{item.qty}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="delivery-section">
          <h2 className="section-title">Livraison</h2>
          <div className="delivery-info">
            <p>Adresse: {livraisonAdresse?.adresse}</p>
            <p>
              Date:{" "}
              {date_livraison &&
                `${date_livraison.getDate()}/${
                  date_livraison.getMonth() + 1
                }/${date_livraison.getFullYear()}`}
            </p>
          </div>
        </div>

        <div className="total-section">
          <h2 className="section-title">Total Commande</h2>
          <p className="total-price">{chariot?.totalePrix.toFixed(3)} DT</p>
        </div>
      </div>
    </div>
  );
};

export default CommandeRecap;
